import React, { forwardRef, MutableRefObject } from 'react';
import styled from '@emotion/styled';
import colours from '~/utils/colours';

export enum TextInputType {
  Text = 'text',
  Number = 'number',
  Password = 'password',
  Email = 'email',
}

export interface TextInputProps
  extends React.ComponentPropsWithoutRef<'input'> {
  error?: boolean;
  type: TextInputType;
}

const TextInputComponent = styled.input<TextInputProps>`
  line-height: 40px;
  border: 1px solid
    ${(props) => (props.error ? colours.red : colours.borderLightGrey)};
  border-radius: 5px;
  width: 100%;
  padding: 0 20px;
  color: ${colours.greyDarkAl2};

  &:active,
  &:focus {
    outline: none;
    border: 1px solid ${colours.blue};
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: ${colours.greyLightAlt3};
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: ${colours.greyLightAlt3};
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: ${colours.greyLightAlt3};
  }
`;

const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    props: TextInputProps,
    ref:
      | ((instance: HTMLInputElement | null) => void)
      | MutableRefObject<HTMLInputElement | null>
      | null
  ) => <TextInputComponent ref={ref} {...props} />
);

export default TextInput;
